// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.password.HpApiUserPasswordV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type { HpApiResponseDto, HpUserPasswordUpdateRequestDto } from '../..';

export const HpApiUserPasswordV3Handler_update_Path = '/api/web/v3/user/password/update';

/**
 * Update the signed-in user's password, authorized by the current password or a reset token
 */
export const HpApiUserPasswordV3Handler_update = (postData: HpUserPasswordUpdateRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpUserPasswordUpdateRequestDto, HpApiResponseDto<boolean>>(
    {
      endpoint: HpApiUserPasswordV3Handler_update_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};
